(function(jQuery, Drupal) {
  'use strict';

  Drupal.behaviors.homepageAnnouncements = {
    attach: function(context, settings) {
      var $announcementSlider = jQuery('.field--name-field-announcement');

      function hpSliderSlideHeight() {
        const $slides = $announcementSlider.find('.field__item');
        // normalize heights
        var m = 0;
        $slides.css({'height': ''});
        $slides.each(function() {
          m = Math.max(m, jQuery(this).outerHeight(true));
        });
        $slides.css({'height': m + 'px'});
      }

      function hpSliderRefresh() {
        if ($announcementSlider.length > 0) {
          $announcementSlider.each(function() {
            const $slider = jQuery(this);
            hpSliderSlideHeight();
            $slider.slick('reinit');
          });
        }
      }

      function hpSliderInit() {
        if ($announcementSlider.length > 0) {
          $announcementSlider.each(function() {
            hpSliderSlideHeight();
            const $slider = jQuery(this);

            $slider
              .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                jQuery('.slides-numbers .active').html(nextSlide + 1);
              })
              .on('init', function(event, slick) {
                jQuery('.slides-numbers .total').html(slick.$slides.length);
                if (slick.$slides.length > 1) {
                  jQuery('.homepage-announcements').show();
                }
              })
              .slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                infinite: false,
                vertical: true,
                adaptiveHeight: true,
                rows: 0,
                nextArrow: '.hp-announcements-controls .slick-next',
                prevArrow: '.hp-announcements-controls .slick-prev'
              });
          });
        }
      }

      jQuery(document).ready(function() {
        if (!window.hpSliderInit) {
          window.hpSliderInit = true;
          hpSliderInit();
        }
      });
      let winDebounce = null;
      jQuery(window).resize(function() {
        winDebounce = setTimeout(function() {
          clearTimeout(winDebounce);
          hpSliderRefresh();
        }, 200);
      });
    }
  };
})(jQuery, Drupal);
